export default "__VITE_ASSET__a70c4079__"